import React from 'react'
import { useIntl } from 'react-intl'
import { Select } from 'mailup-web-components'
import PropTypes from 'prop-types'
import { socialOptions } from './utils'

const SocialSelect = ({ value, onChange, disabled, alreadySelected }) => {
  const intl = useIntl()

  const getOptions = () => {
    const alreadySelectedSet = new Set(alreadySelected)
    const sOptions = socialOptions.filter(e => !alreadySelectedSet.has(e.value))
    // aggiungo l'elemento selezionato
    sOptions.push(
      value === '' ? value : socialOptions.find(e => e.value === value)
    )
    return sOptions
  }
  return (
    <Select
      options={getOptions()}
      placeholder={intl.formatMessage({
        id: 'Load.ContentDefaults.SelectASocial'
      })}
      value={value}
      onChange={onChange}
      searchable
      disabled={disabled}
    />
  )
}

export default SocialSelect

SocialSelect.propTypes = {
  value: PropTypes.num,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  alreadySelected: PropTypes.array
}
